import ApiService from './api';
import qs from 'qs';

const DroponService = {

        createCustomer: async function (data) {
            const customerData = {
                customer: {
                    delivery_address: data.delivery_address,
                    same_address: true,
                    bus: data.bus,
                    company: data.company,
                    description: null,
                    email: data.email,
                    geometry: data.geometry,
                    name: data.company,
                    phone: data.phone,
                    notify_mail: {
                        created: true,
                        scanned: false,
                        tripstart: false,
                        tripstartBulk: false,
                        delay: false,
                        nothome: false,
                        abortother: false,
                        neighbour: false,
                        planned: false
                    },
                    routing: {
                        enabled: false,
                        priority: false,
                        delivery_timeslot: false,
                        only_car: false
                    },
                    scanning: false,
                    type: "billable",
                    url: null,
                    vat: data.vat
                }
            };

            const userData = {
                user: {
                    first_name: data.firstname,
                    last_name: data.lastname,
                    email: data.email,
                    role: "customer",
                    type: "employee",
                    customer: {
                        id: "",
                        name: ""
                    },
                    send_mail: true
                }

            };
            console.log(JSON.stringify({customerData, userData}));

            try {
                const response = await ApiService.post(`${process.env.VUE_APP_ROOT_API_ENV}/vpacks/register`, qs.stringify({
                    customerData,
                    userData
                }));
                console.log(response);
                if (response.status) {
                    console.log('-- create customer & user ok --');
                    this.sendRegisterConfirmation(
                        response.data.output.customerdata.customer.company,
                        response.data.output.customerdata.customer.email,
                        response.data.output.customerdata.customer.phone,
                        response.data.output.userdata.user.first_name,
                        response.data.output.userdata.user.last_name
                    );
                    return response.data;
                } else {
                    return false;
                }
            } catch (error) {
                console.warn('!! create customer & user error ', error);
                return false;
            }
        },

        sendRegisterConfirmation: function (company,email,phone,fname,lname) {
            const data = {
                profile: "VPACKS",
                template: "",
                emailto: "pakjes@v-tax.be;bert@huureenstuur.be",
                attachments: "",
                id: "",
                lang: "NL",
                tekstvoor: "Er werd een nieuwe gebruiker geregistreerd",
                tekstna: `<p>${company}</p><p>${fname} ${lname}</p><p>${email}</p><p>${phone}</p>`,
                subject: "Nieuwe gebruiker V-packs"
            };
            ApiService.post(`${process.env.VUE_APP_ROOT_API_ENV}/sendmail/SendemailVpacks`, qs.stringify(data))
                .then(response => {
                    if (response.status) {
                        console.log('-- register confirmation sent! --');
                        return true;
                    }
                    console.log('!! error sending register confirmation');
                    return false;
                }).catch(error => {
                console.log('!! error sending register confirmation', error);
                return false;
            });
        }
    };

export default DroponService;